var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Index.less');

var AdvertisingBanner = require('front/components/AdvertisingBanner/AdvertisingBanner');
var IndexSlider = require('front/components/IndexSlider/IndexSlider');
var IndexFeatured = require('front/components/IndexFeatured/IndexFeatured');
var CommonEventsList = require('front/components/CommonEventsList/CommonEventsList');
var JoinHowTo = require('front/components/JoinHowTo/JoinHowTo');
var IndexPerspective = require('front/components/IndexPerspective/IndexPerspective');
var IndexSocials = require('front/components/IndexSocials/IndexSocials');

module.exports = Section.extend({

    el: '.Index',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AdvertisingBanner': {selector: '.AdvertisingBanner', viewConstructor: AdvertisingBanner},
        'IndexSlider': {selector: '.IndexSlider', viewConstructor: IndexSlider},
        'IndexFeatured': {selector: '.IndexFeatured', viewConstructor: IndexFeatured},
        'CommonEventsList': {selector: '.CommonEventsList', viewConstructor: CommonEventsList},
        'JoinHowTo': {selector: '.JoinHowTo', viewConstructor: JoinHowTo},
        'IndexPerspective': {selector: '.IndexPerspective', viewConstructor: IndexPerspective},
        'IndexSocials': {selector: '.IndexSocials', viewConstructor: IndexSocials}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onScroll');

        $(window).bind('scroll', this.onScroll);

        this.$('.Index-arrow').addClass('Index-arrow--animating');

        Section.prototype.initialize.call(this, options);
    },


    onScroll: function () {
        if ($(window).scrollTop() > 50) {
            $(window).unbind('scroll', 'onScroll');
            this.$('.Index-arrow').fadeOut(300);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/Index.js
// module id = 271
// module chunks = 0